import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/teacher-mobile.css'

// 忽略 ResizeObserver 警告（这是浏览器内部警告，不影响功能）
const originalError = console.error
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver')) {
    return
  }
  originalError.apply(console, args)
}

const app = createApp(App)

app.use(router)
app.use(store)
app.use(ElementPlus)

// 全局错误处理
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue错误:', err, info)
  // 可以在这里添加错误上报
}

// 未捕获的Promise错误处理
window.addEventListener('unhandledrejection', event => {
  console.error('未处理的Promise错误:', event.reason)
  // 阻止默认的错误输出到控制台（可选）
  // event.preventDefault()
})

// 检查是否有重复的#app元素
if (document.querySelectorAll('#app').length > 1) {
  console.warn('警告: 发现多个#app元素，可能是浏览器扩展注入的内容')
}

app.mount('#app')

